import { FC, useEffect, useState } from "react";
import { DefaultGrid } from "../../../components/grids/default/defaultGrid";
import { IPluginSettingTypeDTO } from "../../../libs/coreapi-dto/service/pluginSettingType";
import useGridFilter from "../../../system/hooks/useGridFilter";
import { useAppContext } from "../../../system/providers/appContextProvider";

const DefaultPluginSettingsGrid: FC<IGridProps> = (props) => {
    const appCtx = useAppContext();
    const [data, setData] = useState<IPluginSettingTypeDTO[]>([]);
    const [totalCount, setTotalCount] = useState(0);
    const [gridFilter, dispatchGridFilter] = useGridFilter();
    const [selectedItem, setSelectedItem] = useState<IGridRow>();

    const loadData = () => {
        appCtx.uiApiService.uiDefaultPluginSettingsRequest.all((response) => {
            if (response.respType === "isCompleted") {
                setData(response.data)
            }
        })
    }

    useEffect(() => {
        loadData()
    }, [])

    return (
                  
        <DefaultGrid
            separator
            gridId={props.gridId}
            data={data}
            totalCount={totalCount}
            filter={gridFilter}
            plugin={props.plugin}
            selectedItem={selectedItem}
            dataProvider={null}
            multipleSelect={props.multipleSelect}
            onSelect={(row) => {
                setSelectedItem(row)
                props?.onSelect?.(row)
            }}
            onDoubleClick={(i) => props.onDoubleClick?.(i)}
            onSort={(i) => dispatchGridFilter({ type: "sort", payload: i.propertyName })}
            onFilterDelete={(i) => dispatchGridFilter({ type: "deleteColumnFilter", payload: i.propertyName })}
            onPageNumberChange={(n) => dispatchGridFilter({ type: "changePageNumber", payload: { pageNumber: n } })}
            onNumberPerPageChange={(n) => dispatchGridFilter({ type: "changeNumberPerPage", payload: { numberPerPage: n } })}
        />

          
    )
}

export default DefaultPluginSettingsGrid
